import script from "./ESTBanner.vue?vue&type=script&lang=ts&setup=true"
export * from "./ESTBanner.vue?vue&type=script&lang=ts&setup=true"

import "./ESTBanner.vue?vue&type=style&index=0&id=0f916872&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f916872"]])

export default __exports__